/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Iban } from "./Iban";
import { IbanAttributeMaster } from "./IbanAttributeMaster";
import { Pa } from "./Pa";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

export enum IbanStatusEnum {
  "ENABLED" = "ENABLED",

  "DISABLED" = "DISABLED",

  "NA" = "NA"
}

// required attributes
const IbanMasterR = t.interface({});

// optional attributes
const IbanMasterO = t.partial({
  description: t.string,

  fkIban: t.Integer,

  fkPa: t.Integer,

  ibanStatus: enumType<IbanStatusEnum>(IbanStatusEnum, "ibanStatus"),

  insertedDate: UTCISODateFromString,

  objId: t.Integer,

  validityDate: UTCISODateFromString
});
// NOTE: fix-circular-generated-models: patched to break a circular
// import cycle detected among: InformativePaFasce, InformativePaDetail, InformativePaMaster, IbanValidiPerPa, IbanAttributeMaster, Iban, IbanMaster, Pa.
// This block is regenerated automatically by
// scripts/fix-circular-generated-models.js after every `gen-api-models` run
// - do not hand-edit `generated/` files, they are wiped on each generation.
export type IbanMaster = t.TypeOf<typeof IbanMasterR> &
  t.TypeOf<typeof IbanMasterO> & {
  readonly "iban"?: Iban;
  readonly "ibanAttributesMasters"?: ReadonlyArray<IbanAttributeMaster>;
  readonly "pa"?: Pa;
  };

export const IbanMaster: t.Type<IbanMaster> = t.recursion("IbanMaster", () =>
  t.intersection(
    [IbanMasterR, t.partial({ ...IbanMasterO.props, "iban": Iban, "ibanAttributesMasters": t.readonlyArray(
    IbanAttributeMaster,
    "array of IbanAttributeMaster"
  ), "pa": Pa })],
    "IbanMaster"
  ) as unknown as t.Type<IbanMaster>
);
